import React from 'react';
import styled from '@emotion/styled';
import Navigation from './Navigation';

const StyledNav = styled.div`
  display: flex;
  flex-flow: column nowrap;
`;

const Navbar = ({ data, location }) => (
  <StyledNav>
    <Navigation data={data} location={location} />
  </StyledNav>
);

export default Navbar;
